import type { VoidFunctionComponent } from 'react';

import { abbrevNumber, prettyNumber } from '../../../../shared/utils';
import { icons } from '../../generic';
import Card from '../../generic/Card/Card';
import HorizontalBarGraph from '../../generic/Graphs/HorizontalBarGraph';
import Tooltip from '../../generic/Tooltip';
import TooltipIcon from '../../generic/TooltipIcon';
import type { StatusBreakdown } from '../../../../shared/types/routes/issueCounts';
import type { BarData } from '../../generic/Graphs/HorizontalBarGraph';

import styles from '../IssueOverview.module.less';

const explainNewIssuesTooltip = 'These counts reflect the number of new active issues added for this category. Because these graphs only track issues that are created, their values may differ from the "total" counts above, which track issues being added and removed from statuses.';

type Props = {
  title: string;
  status?: StatusBreakdown;
  data: BarData[];
};

const CategoryGraph: VoidFunctionComponent<Props> = ({ data, status, title }) => {
  return (
    <Card variant="fill" isFullWidth isContentFullHeight>
      <Card.Header>
        <div className={styles.breakdownHeader}>
          <span>{title}</span>
          <TooltipIcon id="breakdown-header" icon={icons.circleQuestion} tooltip={explainNewIssuesTooltip} />
        </div>
      </Card.Header>
      <Card.Content>
        <div className={styles.breakdown}>
          <HorizontalBarGraph showTooltips data={data} yAxisConfig={{ width: 105 }} />
          <div className={styles.statusSection}>
            <div>
              <span className={styles.label}>Not Shown:</span>
            </div>
            <div>
              <Tooltip
                id="remediated-count"
                tooltip={`Ignored: ${status?.ignored ? prettyNumber(status.ignored) : 'n/a'}`}
              >
                <span>
                  <span className={styles.label}>Ignored </span>
                  <span className={styles.count}>{status?.ignored !== undefined ? abbrevNumber(status.ignored) : 'n/a'}</span>
                </span>
              </Tooltip>
            </div>
            <div>
              <Tooltip
                id="remediated-count"
                tooltip={`Remediated: ${status?.remediated ? prettyNumber(status.remediated) : 'n/a'}`}
              >
                <span>
                  <span className={styles.label}>Remediated </span>
                  <span className={styles.count}>{status?.remediated !== undefined ? abbrevNumber(status.remediated) : 'n/a'}</span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default CategoryGraph;
